export default __webpack_public_path__ + "static/media/Stryker_LateralDer.ee89e3dc.webp";